import { Component } from '@verndale/core';

class Chatbot extends Component {
  setupDefaults() {
    this.dom = {
      triggers: this.el.querySelectorAll('[data-chatbot-trigger="true"]')
    };

    setTimeout(() => {
      this.chatObserver();
    }, 1000);
  }

  addListeners() {
    this.dom.triggers.forEach(trigger =>
      trigger.addEventListener('click', this.handleClick.bind(this))
    );

    window.addEventListener('resize', this.chatObserver.bind(this));
  }

  handleClick(e) {
    e.preventDefault();
    e.target.blur();

    window.askSiplastClick();
    this.chatObserver();
  }
  chatObserver() {
    let observer;
    if (observer) {
      observer.disconnect();
      observer = null;
    }

    if (window.matchMedia('(max-width: 576px)').matches) {
      observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.target.className === 'siplast-chat siplast-chat--open' && window.innerWidth <= 576) {
            if (document.body.classList.contains('siplast-chat--open')) {
              document.querySelector('#gaf-genius-widget-root').classList.add('chat-open');
              document.querySelector('#HomePage').style.height = '90%';
              document.querySelector('#HomePage').style.top = '55%';
            }
          } else {
            document.querySelector('#gaf-genius-widget-root').classList.remove('chat-open');
            document.querySelector('#HomePage').style.removeProperty('height');
            document.querySelector('#HomePage').style.removeProperty('top');
          }
        });
      });

      observer.observe(document.body, {
        attributes: true
      });
    }
  }
}

export default Chatbot;
